import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ChipSelectOption } from '@predictiveindex/tapestry';

export const maxStakeholders =
    (max: number): ValidatorFn =>
    (control: AbstractControl<string[]>): ValidationErrors | null => {
        if (Array.isArray(control.value) && control.value.length > max) {
            return { maxStakeholders: true };
        }

        return null;
    };

export const validateEmails =
    (validDomains: string[]): ValidatorFn =>
    (control: AbstractControl<string[]>): ValidationErrors | null => {
        const validEmailRegEx =
            /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        const validEmails = control.value.filter((v) =>
            validEmailRegEx.test(v)
        );
        const invalidEmails = control.value.filter(
            (v) => !validEmailRegEx.test(v)
        );
        const invalidDomains = validEmails
            .map((v) => `@${v.split('@')[1]}`)
            .filter((v) => !validDomains.includes(v));

        const invalidResult = {
            invalidEmails: false,
            invalidDomains: false
        };

        if (invalidEmails?.length) {
            invalidResult.invalidEmails = true;
        }

        if (invalidDomains?.length) {
            invalidResult.invalidDomains = true;
        }

        if (Object.values(invalidResult)?.some((v) => v)) {
            return invalidResult;
        }

        return null;
    };

export const minLinkOwner =
    (min: number): ValidatorFn =>
    (control: AbstractControl<ChipSelectOption[]>): ValidationErrors | null => {
        if (
            !control.value ||
            (Array.isArray(control.value) && control.value.length < min)
        ) {
            return { minLinkOwner: true };
        }

        return null;
    };

export const maxLinkOwner =
    (max: number): ValidatorFn =>
    (control: AbstractControl<ChipSelectOption[]>): ValidationErrors | null => {
        if (Array.isArray(control.value) && control.value.length > max) {
            return { maxLinkOwner: true };
        }

        return null;
    };
